import React, { Component } from 'react'
import { GroupBrowseContainer } from './GroupBrowse'
import { MediaBrowseContainer } from './MediaBrowse'
import './navigation.css'
import PropTypes from 'prop-types'

export class Navigation extends Component
{
    static propTypes = {
        isResponsiveMode: PropTypes.bool.isRequired,
    }

    render()
    {
        const { isResponsiveMode } = this.props

        return (
            <React.Fragment>
                {
                    ! isResponsiveMode && <GroupBrowseContainer />
                }

                <MediaBrowseContainer />
            </React.Fragment>
        )
    }
}
